import React, { useMemo } from 'react';
import { ShopifyProduct } from '../../lib/types/product';
import { Box } from 'grommet';
import ProductCardInfo from '../Product/ProductCardInfo';
import { findMemoVariant } from '../../lib/product';

type Props = {
  product: ShopifyProduct;
  collectionContext?: object;
};

export function WallcoveringsGridOverlayCard({
  product,
  collectionContext,
}: Props) {
  const gridImage = React.useMemo(
    () =>
      product.media?.find((m) =>
        m.image.originalSrc.toLowerCase().includes('_grid')
      ),
    [product.media]
  );
  const hoverImage = useMemo(
    () =>
      product.media?.find((m) =>
        m.image.originalSrc.toLowerCase().includes('_hover')
      ),
    [product.media]
  );

  const imageUrl =
    hoverImage?.image.originalSrc || gridImage?.image.originalSrc;

  const sampleVariant = findMemoVariant(product.variants);

  return (
    <Box style={{ zIndex: 10 }} fill>
      <ProductCardInfo
        fill
        backgroundColor="transparent"
        isDark={false}
        detailsPath={`/products/${product.handle}`}
        collectionContext={collectionContext}
        imageUrl={imageUrl}
        srcSetOptions={
          hoverImage
            ? {
                q: 80,
                auto: ['format', 'compress'],
                ar: '1:1',
                fit: 'crop',
                crop: 'entropy',
              }
            : {
                q: 80,
                auto: ['format', 'compress'],
                ar: '1:1',
                fit: 'crop',
                crop: 'entropy',
                rect: '200,200,800,800',
              }
        }
        sampleVariant={{ ...sampleVariant, productType: product.productType }}
        {...product}
        title=""
        description={undefined}
        srcSetSizes="(max-width: 768px) 80vw, 25vw"
      />
    </Box>
  );
}
